module.exports = __webpack_public_path__ + "img/datav_bg3.fac20804.png";